export default __webpack_public_path__ + "static/media/nfc-animation.97b323c4.gif";